/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/155-pie-chart': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M7 9V2a7 7 0 106.262 3.869L7 9zm7.262-5.131A6.999 6.999 0 008 0v7l6.262-3.131z"/>'
  }
})
